import React from 'react'
import { Row, Col, Divider, Button } from 'antd'

import { RightOutlined } from '@ant-design/icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCheck } from '@fortawesome/free-solid-svg-icons'
import { faDotCircle, faCircle } from '@fortawesome/free-regular-svg-icons'

import './ProgressBar.scss'

// const { Step } = Steps;

const ProgressBar = props => {
  const {
    companyStageOneStatus,
    companyStageTwoStatus,
    finalProgressStatus,
    stepStatus,
    inProgressItem,
    registrationStatus,
    productSelectionStatus,
    preQualificationStatus,
  } = props

  const complete = (
    <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#a21e41', fontSize: '16px' }} />
  )
  const inComplete = (
    <FontAwesomeIcon icon={faCircle} style={{ color: '#a21e41', fontSize: '16px' }} />
  )
  const inProgress = (
    <FontAwesomeIcon icon={faDotCircle} style={{ color: '#a21e41', fontSize: '16px' }} />
  )
  const check = <FontAwesomeIcon icon={faCheck} style={{ color: '#ffff', fontSize: '12px' }} />
  const divider = (
    <Divider
      plain
      style={{
        border: '1px solid #A21E41',
        background: '#A21E41',
        marginTop: '10px',
        marginLeft: '-3px',
        width: '100%',
      }}
    />
  )

  const registerProgressItem = inProgressItem === 'register' ? inProgress : inComplete
  const productsProgressItem = inProgressItem === 'products' ? inProgress : inComplete
  const prequalificationProgressItem =
    inProgressItem === 'prequalification' ? inProgress : inComplete
  const companyStageOneProgressItem =
    inProgressItem === 'stage_one_company_info' ? inProgress : inComplete
  const companyStageTwoProgressItem =
    inProgressItem === 'stage_two_company_info' ? inProgress : inComplete
  const progressLastStatus = inProgressItem === 'completed' ? inProgress : inComplete

  const stepOne = stepStatus.includes('stepOne_completed')
  const stepTwo = stepStatus.includes('stepTwo_completed')
  const stepThree = stepStatus.includes('stepThree_completed')
  return (
    <div style={{ marginTop: '-25px', marginBottom: '-11px' }}>
      <Row>
        <Col className="gutter-row" span={8}>
          <div className="gl-steps">
            <Button shape="circle" size="small" className={stepOne ? 'stepSuccess' : 'defaultStep'}>
              <div>
                {stepStatus.includes('stepOne_completed') ? (
                  check
                ) : (
                  <div style={{ fontWeight: 'bold', color: '#323232', marginTop: '-1px' }}>1</div>
                )}
              </div>
            </Button>
            <strong style={{ fontSize: '13px', marginTop: '1.5px' }}>Register</strong>
            <div style={{ marginTop: '2px', marginLeft: '5px' }}>
              <RightOutlined style={{ color: '#c4c4c4' }} />
            </div>
          </div>
        </Col>
        <Col className="gutter-row" span={11}>
          <div className="gl-steps">
            <Button shape="circle" size="small" className={stepTwo ? 'stepSuccess' : 'defaultStep'}>
              <div>
                {stepStatus.includes('stepTwo_completed') ? (
                  check
                ) : (
                  <div style={{ fontWeight: 'bold', color: '#323232', marginTop: '-1px' }}>2</div>
                )}
              </div>
            </Button>
            <strong style={{ fontSize: '13px', marginTop: '1.5px' }}>Your company</strong>
            <div style={{ marginTop: '2px', marginLeft: '5px' }}>
              <RightOutlined style={{ color: '#c4c4c4' }} />
            </div>
          </div>
        </Col>
        <Col className="gutter-row" span={5}>
          <div className="gl-steps">
            <Button
              shape="circle"
              size="small"
              className={stepThree ? 'stepSuccess' : 'defaultStep'}
            >
              <div>
                {stepStatus.includes('stepThre_completed') ? (
                  check
                ) : (
                  <div style={{ fontWeight: 'bold', color: '#323232', marginTop: '-1px' }}>3</div>
                )}
              </div>
            </Button>
            <strong style={{ fontSize: '13px', marginTop: '1.5px' }}>Submit</strong>
          </div>
        </Col>
      </Row>

      <Row className="progress-log">
        <Col span={2} style={{ display: 'flex' }}>
          {registrationStatus ? complete : registerProgressItem}
          <div style={{ width: '20px', marginTop: '-3px', marginRight: '-4px', marginLeft: '2px' }}>
            {divider}
          </div>
          <br />
        </Col>
        <Col span={2} style={{ display: 'flex' }}>
          {productSelectionStatus ? complete : productsProgressItem}
          <div style={{ width: '20px', marginTop: '-3px', marginRight: '-4px', marginLeft: '2px' }}>
            {divider}
          </div>
          <br />
        </Col>
        <Col span={7} style={{ display: 'flex' }}>
          {preQualificationStatus ? complete : prequalificationProgressItem}
          <div style={{ width: '100%', marginTop: '-3px', marginRight: '-4px', marginLeft: '2px' }}>
            {divider}
          </div>
          <br />
        </Col>
        <Col span={2} style={{ display: 'flex' }}>
          {companyStageOneStatus ? complete : companyStageOneProgressItem}
          <div style={{ width: '20px', marginTop: '-3px', marginRight: '-4px', marginLeft: '2px' }}>
            {divider}
          </div>
          <br />
        </Col>
        <Col span={8} style={{ display: 'flex' }}>
          {companyStageTwoStatus ? complete : companyStageTwoProgressItem}
          <div style={{ width: '100%', marginTop: '-3px', marginRight: '-4px', marginLeft: '2px' }}>
            {divider}
          </div>
          <br />
        </Col>
        <Col span={2} style={{ display: 'flex' }}>
          {finalProgressStatus ? complete : progressLastStatus}
        </Col>
      </Row>
    </div>
  )
}

export default ProgressBar
